import { useState } from 'react';
import './PreChargebackEvaluation.css';
import { getTransactionByUtr } from '../../../../config/LiveApi';
import { toast } from 'react-toastify';

const FoundTxnWithUtr = ({ token }) => {
    const [utr, setUtr] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const handleSearch = async () => {
        if (!utr.trim()) return;

        setLoading(true);
        setError(null);
        setData(null);

        try {
            const result = await getTransactionByUtr(token, utr);
            if (Array.isArray(result) && result.length > 0) {
                setData(result);
            } else {
                setError('No data found');
            }
        } catch (err) {
            setError('Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    const handleCopyToClipboard = () => {
        if (!data || data.length === 0) return;

        const headerRow = tableHeaders.join('\t');
        const dataRows = data.map(row =>
            tableHeaders.map(header => (row[header] ?? '-')).join('\t')
        );

        const tsv = [headerRow, ...dataRows].join('\n');

        navigator.clipboard.writeText(tsv)
            .then(() => toast('Data copied !!'))
            .catch((err) => {
                console.error('Failed to copy: ', err);
                toast.error('Failed to copy data');
            });
    };


    const tableHeaders = [
        'Type', 'Org Name', 'Merchant', 'Provider Name', 'OrderId', 'Status', 'RRN',
        'Amount', 'TXN DATE', 'Payer', 'ADJ DATE', 'Email', 'Phone', 'VPA'
    ];
    return (
        <>
            <div className="cbe-search-bar">
                <input
                    type="text"
                    placeholder="Enter UTR"
                    value={utr}
                    onChange={(e) => setUtr(e.target.value)}
                />
                <button onClick={handleSearch}>Search</button>
            </div>

            {loading && <p className="cbe-loading">Loading...</p>}
            {error && <p className="cbe-error">{error}</p>}

            {data && (
                <>
                    <button className="cbe-copy-btn" onClick={() => handleCopyToClipboard()}>
                        📋 Copy
                    </button>

                    <div className="cbe-table-container">
                        <table className="cbe-table">
                            <thead>
                                <tr>
                                    {tableHeaders.map((header) => (
                                        <th key={header}>{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, index) => (
                                    <tr key={index}>
                                        {tableHeaders.map((header) => (
                                            <td key={header}>{row[header] || '-'}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    )
}

export default FoundTxnWithUtr